import {memo} from 'react';
import Chart from "react-apexcharts";
import {Typography} from "@material-tailwind/react";
import {isDarkMode} from "../../App";
import {useTranslation} from "react-i18next";
import Loader from "../../assets/icons/Loader";

export interface PieChartProps {
    series: number[],
    labels: string[],
    isLoading: boolean;
}

const PieChart = ({series, labels, isLoading}: PieChartProps) => {
    const {t} = useTranslation();
    const colors = [
        '#607d8b',
        '#ffca28',
        '#9ccc65',
        '#26a69a',
        '#d84315',
        '#039be5',
        '#9c27b0',
        '#ff5722',
        '#d84315',
        '#ef5350',
        '#33691e',
        '#00695c'
    ];

    const element = document.getElementById('successful_deposits');
    const legendWidth = element ? (element.offsetWidth > 360 ? 120 : element.offsetWidth - 16) : 320;
    return <>
        {series.length ? <Chart type="pie"
                                width={element ? element.offsetWidth - 16 : '100%'}
                                height={element ? element.offsetHeight - 80 : '100%'}
                                series={series}
                                options={{
                                    chart: {
                                        background: 'transparent'
                                    },
                                    labels: labels,
                                    stroke: {
                                        colors: [isDarkMode? 'transparent': 'white']
                                    },
                                    legend: {
                                        show: true,
                                        position: element && element.offsetWidth > 360 ? "right" : "bottom",
                                        textAnchor: 'start',
                                        horizontalAlign: element && element.offsetWidth > 360 ? 'left' : 'center',
                                        width: legendWidth,
                                        fontSize: '10px',
                                        formatter: (legendName) => {
                                            return legendName.length > 14 ? legendName.substring(0, 11) + '...' : legendName;
                                        }
                                    },
                                    dataLabels: {
                                        enabled: true
                                    },
                                    colors: colors,
                                    theme: {
                                        mode: isDarkMode ? 'dark' : 'light'
                                    }
                                }}
        /> : <>
            <Chart type="pie"
                   width={element ? element.offsetWidth - 16 : '100%'}
                   height={element ? element.offsetHeight - 80 : '100%'}
                   series={[1]}
                   options={{
                       labels: labels,
                       legend: {
                           show: false
                       },
                       dataLabels: {
                           enabled: false
                       },
                       colors: [isDarkMode ?  '#666' :'#cfd8dc'],
                       plotOptions: {
                           pie: {
                               expandOnClick: false
                           }
                       },
                       grid: {
                         borderColor: '#666'
                       },
                       stroke: {
                           colors: [isDarkMode? 'transparent': 'white']
                       },
                       chart: {
                           animations: {
                               enabled: false
                           },
                           zoom: {
                               enabled: false
                           },
                           toolbar: {
                               show: false
                           },
                           background: 'transparent'
                       },
                       states: {
                           active: {
                               filter: {
                                   type: 'none'
                               },
                           },
                           hover: {
                               filter: {
                                   type: 'none'
                               }
                           }
                       },
                       tooltip: {
                           enabled: false
                       },
                       theme: {
                           mode: isDarkMode ? 'dark' : 'light'
                       }
                   }}
            />
            {!isLoading ? <Typography variant="small" className="mb-4 text-center">{t('No data')}</Typography>: ''}
        </>}
        {isLoading ? <div
            className="absolute w-full h-full bg-white dark:bg-black top-0 left-0 opacity-30 flex items-center justify-center rounded-xl">
            <Loader width="w-8 h-8" colors="text-teal-600 fill-white"/>
        </div> :''}
    </>
}

export default memo(PieChart);
